SupportFlexibleEmailFormObjectsTemplate = require '../../../../flexible_email_form_objects.html.mustache'
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormIntlFileInputView extends Backbone.View
  tagName: 'li'

  events:
    'change #fileupload': 'getFileData'
    'click #file_reset': 'resetFileInput'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @elementID = "#email_file_input"
    @model = @options.model
    @isFlexibleStepThree = @options.isFlexibleStepThree
    @label = @model.label
    @required = @model.required is true or @model.required is "true"
    @isInputCompulsory = @model.required is true or @model.required is "true"
    @I18nScope = 'modules.support'
    @template = SupportFlexibleEmailFormObjectsTemplate
    @resetFileData()

  render: ->
    @$el.html(toHtml(@template, @toHash()))

  toHash: ->
    {
      stepThreeType: if @isFlexibleStepThree then 'flexibleStepThree' else 'defaultStepThree'
      file_input_template: @isFileUploadEnabled()
      label: @label
      required: @isInputCompulsory
      counter: @model.counter
    }

  isInputGiven: ->
    @fileData != null || (not @isFileUploadEnabled())

  isFileUploadEnabled: ->
    window.evaluate(experiments?.fileUpload)

  isInputValid: ->
    @validateFileInput()

  validateFileInput: ->
    fileUploadHtmlElement = @getFileInput()
    file = fileUploadHtmlElement.files[0] if fileUploadHtmlElement?.files?.length > 0
    if file?
      @fileName = file.name
      fileFormat = @getFileFormat()
      fileSize = file.size

      acceptedFormats = ['jpg','jpeg','gif','bmp','png','pdf','xls','xlsx','doc','docx','txt','csv','tiff']
      maxSize = 1000000

      if ($.inArray(fileFormat, acceptedFormats) >= 0)  and fileSize < maxSize
        @$(".error_upload").text("")
        true
      else
        err_msg = I18n.translate('js.modules.support.invalid_file_message', acceptedFormats: "#{acceptedFormats}", max_size: 1)
        @$(".error_upload").text(err_msg)
        false
    else
      true

  renderErrorUpload: ->
    $(".error_upload").text('Error uploading file')

  removeUploadError: ->
    $(".error_upload").text('')

  showFileReset: ->
    @$('#file_reset').show()

  hideFileReset: ->
    @$('#file_reset').hide()

  validateEmailForm: ->
    if @isInputCompulsory
      @options.validateEmailForm()

  resetFileInput: ->
    fileControl = $('.fileupload')
    if fileControl?.length > 0
      fileControl.wrap('<form>').closest('form').get(0).reset()
      fileControl.unwrap()
    @resetFileData()
    @hideFileReset()
    @validateEmailForm()

  getFileData: (e) ->
    if @getFileInput()?.files?.length > 0
      @showFileReset()
      reader = new FileReader()
      reader.onloadend = @getFileText
      reader.onerror = @renderErrorUpload
      reader.readAsDataURL(@getFileInput()?.files[0])
    else
      @resetFileData()
      @hideFileReset()


  getFileFormat: ->
    @fileName.split(".")[@fileName.split(".").length - 1].toLowerCase()

  getFileName: ->
    fullPath = @getFileInput()?.value
    startIndex = ((if fullPath.indexOf("\\") >= 0 then fullPath.lastIndexOf("\\") else fullPath.lastIndexOf("/")))
    filename = fullPath.substring(startIndex)
    filename.substring(1)  if filename.indexOf("\\") is 0 or filename.indexOf("/") is 0

  getFileText: (e) ->
    @fileData = e.target.result
    @fileName = @getFileName()
    @validateEmailForm()


  resetFileData: ->
    @fileData = null
    @fileName = null

  getFileInput: ->
    document.getElementById('fileupload')

  populateInput: (data)->
    data.fileData = @fileData
    data.fileName = @fileName

module.exports = EmailFormIntlFileInputView
